import { useBoardSettings } from "providers";
import React, { PropsWithChildren, useCallback, useMemo, useState } from "react";

import { DefaultTemplatesPanel } from "./components/DefaultTemplatesPanel";
import { DefaultTemplatesContext } from "./DefaultTemplatesContext";

export const DefaultTemplatesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { reloadBoardSettings } = useBoardSettings();

  const openPanel = useCallback(() => setIsOpen(true), []);
  const closePanel = useCallback(() => {
    setIsOpen(false);
    reloadBoardSettings();
  }, [reloadBoardSettings]);

  const contextValue = useMemo(() => ({ openPanel }), [openPanel]);

  return (
    <DefaultTemplatesContext.Provider value={contextValue}>
      {children}
      <DefaultTemplatesPanel isOpen={isOpen} onClose={closePanel} />
    </DefaultTemplatesContext.Provider>
  );
};
